import { render, staticRenderFns } from "./postModel.vue?vue&type=template&id=8f4cb39e"
import script from "./postModel.vue?vue&type=script&lang=js"
export * from "./postModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f4cb39e')) {
      api.createRecord('8f4cb39e', component.options)
    } else {
      api.reload('8f4cb39e', component.options)
    }
    module.hot.accept("./postModel.vue?vue&type=template&id=8f4cb39e", function () {
      api.rerender('8f4cb39e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organization/postManage/postModel.vue"
export default component.exports